module.exports = __webpack_public_path__ + "img/fitness-ueberraschung.d6a0c4b4.png";